import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import Modal from 'react-bootstrap/Modal';
import { BDSMForm } from '../../../../components/form/BDSMForm';
import Button from 'react-bootstrap/Button';

export const RecipeOutputModal = ({ onClick }) => {
    const [show, setShow] = useState(false);
    const { t } = useTranslation('recipe');
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const validation = Yup.object().shape({
        title: Yup.string(),
        amountGrams: Yup.number().required(t('validations:required'))
            .min(0.01, t('validations:higherThan') + 0.01),
    });

    const handleSave = (values) => {
        onClick(values);
        handleClose();
    };

    const getFormModel = () => {
        return {
            initValues: { title: '', amountGrams: '' },
            onSubmit: (record) => handleSave(record),
            onCancel: () => handleClose(),
            validationSchema: validation,
            fieldNames: ['title', 'amountGrams'],
            types: ['text', 'number'],
            className: 'mb-3',
            label: [t('output.title'), t('output.amountGrams')],
            selectData: [null, null],
            inputFieldsClass: '',
        };
    };

    return (
        <>
            <Button
                type='submit'
                variant='success'
                className={'button dynamic-quantity'}
                onClick={handleShow}>
                {t('output.addOutput')}
            </Button>
            <Modal show={show} onHide={handleClose} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{t('output.modalTitle')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <BDSMForm form={getFormModel()} />
                </Modal.Body>
            </Modal>
        </>
    );
};